export default __webpack_public_path__ + "static/media/warning-circle.9c884a14.svg";